import * as React from 'react';
import { AdresseTiersReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { formatPrescriberAddress } from '@europrocurement/l2d-utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button, Tooltip, Typography } from '@mui/material';
import { TextIcon } from '../../atoms';

export type AddressLinkProps = {
    address: AdresseTiersReadNoteGroupTimestampableBlameambleGroup | string;
    icon?: IconProp;
    type?: 'text' | 'button';
};

export const AddressLink: React.FunctionComponent<AddressLinkProps> = function (props) {
    const { address, icon, type = 'text' } = props;
    const [onHover, setHover] = React.useState<boolean>(false);

    const longAddress =
        typeof address === 'string' ? address : formatPrescriberAddress(address, 'long');
    const shortAddress =
        typeof address === 'string' ? address : formatPrescriberAddress(address, 'short');

    const openGoogleMapTab = () => {
        const mapQueryUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(longAddress)}`;
        window.open(mapQueryUrl, '_blank');
    };

    const locationIcon: IconProp = ['fasl', 'location-dot'];

    const hoverProps = {
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false),
    };

    const tooltipTitle = 'Cliquer pour ouvrir dans Google Maps';

    if (type === 'text') {
        const pointerOnHover = {
            cursor: onHover ? 'pointer' : '',
        };
        return (
            <Tooltip title={tooltipTitle}>
                <Typography
                    {...hoverProps}
                    sx={pointerOnHover}
                    onClick={openGoogleMapTab}
                >
                    {shortAddress}
                </Typography>
            </Tooltip>
        );
    }

    const subtitleElementStyle = {
        display: 'flex',
        opacity: 0.6,
        fontSize: '12px',
        fontWeight: '300',
        alignItems: 'center',
        marginRight: '10px',
        color: 'inherit',
    };

    return (
        <Tooltip title={tooltipTitle}>
            <Button
                data-testid="AddressLink-test-id"
                onClick={openGoogleMapTab}
                sx={subtitleElementStyle}
            >
                <TextIcon
                    icon={{ props: { icon: icon || locationIcon } }}
                    gap="4px"
                >
                    <Typography>{shortAddress}</Typography>
                </TextIcon>
            </Button>
        </Tooltip>
    );
};
